import { render, staticRenderFns } from "./Modifica.vue?vue&type=template&id=238d87e8&scoped=true&"
import script from "./Modifica.vue?vue&type=script&scoped=true&lang=js&"
export * from "./Modifica.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./Modifica.vue?vue&type=style&index=0&id=238d87e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238d87e8",
  null
  
)

export default component.exports